import { observer } from "mobx-react-lite";
import React from "react";

import { FlowVersion } from "src/api/flowTypes";
import { ContinueEditingVersionButton } from "src/flowContainer/ContinueEditingVersionButton/ContinueEditingVersionButton";

type WrapperProps = {
  version: FlowVersion;
};

export const ContinueEditingVersionButtonWrapper: React.FC<WrapperProps> =
  observer(({ version }) => {
    return <ContinueEditingVersionButton key={version.id} />;
  });
